<template>

    <v-card class="pa-6 ma-md-10 bg-white-show-through">

        <!-- title -->
        <v-card-title class="card-title">
            <v-icon large class="indigo--text mr-3">{{$t('client.locations.icon')}}</v-icon> {{ $t('client.locations.title')}}
        </v-card-title>

        <v-divider class="my-4"></v-divider>

        <v-card-text>

            <v-row>

                <v-col cols="12">

                    <AppAlert v-if="error" :alert="error" />

                    <v-skeleton-loader v-if="isLoading" v-bind="attrs" type="list-item-three-line" style="height: 8em;"></v-skeleton-loader>

                    <v-simple-table v-if="!isLoading">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">N°</th>
                                    <th class="text-left">{{ $t("client.locations.car")}}</th>
                                    <th class="text-left">{{ $t("client.locations.start_date")}}</th>
                                    <th class="text-left">{{ $t("client.locations.end_date")}}</th>
                                    <th class="text-left">{{ $t("client.locations.renter")}}</th>
                                    <th class="text-left">{{ $t("admin.agencies.agency")}}</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(location, i) in locations" :key="i" class="py-2">
                                    <td>{{location.id}}</td>
                                    <td>{{location.car.model}}</td>
                                    <td>{{location.startTimeString}}</td>
                                    <td>{{location.endTimeString}}</td>
                                    <td>{{location.tenant.name}}</td>
                                    <td><b>{{location.car.agency.name}}</b> {{location.car.agency.address}} <br>  {{location.car.agency.phoneNumbers}}</td>
                                    <td>
                                        <v-btn icon :to="{name: 'locationDetails', params: {id: location.id}}" :title="$t('shared.more_details')">
                                            <v-icon class="indigo--text">mdi-dots-horizontal</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-col>
                <v-col cols="12">
                    <v-btn icon @click="getLocations()">
                        <v-icon class="indigo--text">mdi-refresh</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import { LocationsApi } from '../../../shared/services/api/locations'

export default {
    name: "Locations",
    data () {
        return {
            locations: [],
            isLoading: false,
            error: null,
            attrs: {
                class: 'mb-6',
                boilerplate: true,
                elevation: 2
            }
        }
    },
    methods: {
        getLocations () {
            this.isLoading = true;
            LocationsApi.myLocations()
                .then(locations => this.locations = locations)
                .catch(error => this.error = error)
                .finally(() => this.isLoading = false);
        }
    },
    mounted () {
        this.getLocations();
    }
}
</script>

<style scoped>

</style>
